const DATE_FORMAT_REGEX_PATTERNS = [
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01]), (\d{4})$/i,
        mask: "MMMM DD, YYYY",
        locale: "en"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01]), (\d{2})$/i,
        mask: "MMMM DD, YY",
        locale: "en"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) de (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) de (\d{4})$/i,
        mask: "DD MMMM YYYY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{4})$/i,
        mask: "DD MMMM YYYY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) de (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) de (\d{2})$/i,
        mask: "DD MMMM YY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{2})$/i,
        mask: "DD MMMM YY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) de (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\.? de (\d{4})$/i,
        mask: "DD MMM YYYY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) de (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\.? de (\d{2})$/i,
        mask: "DD MMM YY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\.? (\d{4})$/i,
        mask: "DD MMM YYYY",
        locale: "es"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\.? (\d{2})$/i,
        mask: "DD MMM YY",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\.? ([0-2]?[1-9]|3[01]), (\d{4})$/i,
        mask: "MMM DD, YYYY",
        locale: "en"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\.? ([0-2]?[1-9]|3[01]), (\d{2})$/i,
        mask: "MMM DD, YY",
        locale: "en"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{4})$/i,
        mask: "DD MMMM YYYY",
        locale: "en"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{2})$/i,
        mask: "DD MMMM YY",
        locale: "en"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\.? (\d{4})$/i,
        mask: "DD MMM YYYY",
        locale: "en"
    },
    {
        regex: /^([0-2]?[1-9]|3[01]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\.? (\d{2})$/i,
        mask: "DD MMM YY",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})Z$/,
        mask: "YYYY-MM-DD HH:mm:ss.SSSz"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})Z$/,
        mask: "YYYY/MM/DD HH:mm:ss.SSSz"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})Z$/,
        mask: "YYYY-MM-DDTHH:mm:ss.SSSz"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})Z$/,
        mask: "YYYY/MM/DDTHH:mm:ss.SSSz"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})([+-](0[1-9]|1[0-4]):[0-5]\d)$/,
        mask: "YYYY-MM-DDTHH:mm:ss.SSSZ"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\.(\d{3})([+-](0[1-9]|1[0-4]):[0-5]\d)$/,
        mask: "YYYY/MM/DDTHH:mm:ss.SSSZ"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "YYYY-MM-DDTHH:mm:ss"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "YYYY/MM/DDTHH:mm:ss"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)Z$/,
        mask: "YYYY-MM-DDTHH:mm:ssz"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)Z$/,
        mask: "YYYY/MM/DDTHH:mm:ssz"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-](0[1-9]|1[0-4]):[0-5]\d)$/,
        mask: "YYYY-MM-DDTHH:mm:ssZ"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-](0[1-9]|1[0-4]):[0-5]\d)$/,
        mask: "YYYY/MM/DDTHH:mm:ssZ"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-(\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "MM-DD-YY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "MM/DD/YY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-(\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "DD-MM-YY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "DD/MM/YY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "DD-MM-YYYY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "DD/MM/YYYY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "MM-DD-YYYY HH:mm:ss"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        mask: "MM/DD/YYYY HH:mm:ss"
    },
    {
        regex: /^\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        mask: "YY-MM-DD"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-(\d{2})$/,
        mask: "DD-MM-YY"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-(\d{2})$/,
        mask: "MM-DD-YY"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-(\d{4})$/,
        mask: "DD-MM-YYYY"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-(\d{4})$/,
        mask: "MM-DD-YYYY"
    },
    {
        regex: /^(\d{2})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/,
        mask: "YY/MM/DD"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{2})$/,
        mask: "DD/MM/YY"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{2})$/,
        mask: "MM/DD/YY"
    },
    {
        regex: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/,
        mask: "DD/MM/YYYY"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/,
        mask: "MM/DD/YYYY"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|1[0-2]) \d{2}$/i,
        mask: "MMM DD YY",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|1[0-2]) \d{2}$/i,
        mask: "MMM DD YY",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(0[1-9]|1[0-2])-\d{2}$/i,
        mask: "MMM-DD-YY",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(0[1-9]|1[0-2])-\d{2}$/i,
        mask: "MMM-DD-YY",
        locale: "es"
    },
    {
        regex: /^(\d{4}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|1[0-2])$/i,
        mask: "YYYY MMM DD",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|1[0-2])$/i,
        mask: "YYYY MMM DD",
        locale: "es"
    },
    {
        regex: /^(\d{4})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(0[1-9]|1[0-2])$/i,
        mask: "YYYY-MMM-DD",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(0[1-9]|1[0-2])$/i,
        mask: "YYYY-MMM-DD",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|1[0-2]) (\d{4}) $/i,
        mask: "MMM DD YYYY",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|1[0-2]) (\d{4})$/i,
        mask: "MMM DD YYYY",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(0[1-9]|1[0-2])-(\d{4}) $/i,
        mask: "MMM-DD-YYYY",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(0[1-9]|1[0-2])-(\d{4})$/i,
        mask: "MMM-DD-YYYY",
        locale: "es"
    },
    {
        regex: /^(\d{2}) (January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01])$/i,
        mask: "YY MMMM DD",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) ([0-2]?[1-9]|3[01])$/i,
        mask: "YY MMMM DD",
        locale: "es"
    },
    {
        regex: /^(\d{2})-(January|February|March|April|May|June|July|August|September|October|November|December)-([0-2]?[1-9]|3[01])$/i,
        mask: "YY-MMMM-DD",
        locale: "en"
    },
    {
        regex: /^(\d{2})-(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)-([0-2]?[1-9]|3[01])$/i,
        mask: "YY-MMMM-DD",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01]) (\d{2})$/i,
        mask: "MMMM DD YY",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) ([0-2]?[1-9]|3[01]) (\d{2})$/i,
        mask: "MMMM DD YY",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01]) (\d{2})$/i,
        mask: "MMMM-DD-YY",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)-([0-2]?[1-9]|3[01])-(\d{2})$/i,
        mask: "MMMM-DD-YY",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) ([0-2]?[1-9]|3[01]) (\d{4})$/i,
        mask: "MMMM DD YYYY",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) ([0-2]?[1-9]|3[01]) (\d{4})$/i,
        mask: "MMMM DD YYYY",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December)-([0-2]?[1-9]|3[01])-(\d{4})$/i,
        mask: "MMMM-DD-YYYY",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)-([0-2]?[1-9]|3[01])-(\d{4})$/i,
        mask: "MMMM-DD-YYYY",
        locale: "es"
    },
    {
        regex: /^(\d{2})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
        mask: "YY-MM-DD HH:mm:ss"
    },
    {
        regex: /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
        mask: "YYYY-MM-DD HH:mm:ss"
    },
    {
        regex: /^(\d{2})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
        mask: "YY/MM/DD HH:mm:ss"
    },
    {
        regex: /^(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
        mask: "YYYY/MM/DD HH:mm:ss"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/,
        mask: "YYYY/MM/DD"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        mask: "YYYY-MM-DD"
    },
    {
        regex: /^(\d{4})(\d{2})(\d{2})$/,
        mask: "YYYYMMDD"
    },
    {
        regex: /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})$/,
        mask: "YYYYMMDDTHHmmss"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\s(AM|PM|am|pm))$/,
        mask: "DD/MM/YYYY LTS",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[01])-(0[1-9]|1[0-2])-(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\s(AM|PM|am|pm))$/,
        mask: "DD-MM-YYYY LTS",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2]\d|3[01])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\s(AM|PM|am|pm))$/,
        mask: "MM/DD/YYYY LTS",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[01])-(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\s(AM|PM|am|pm))$/,
        mask: "MM-DD-YYYY LTS",
        locale: "es"
    },
    {
        regex: /^(\d{2}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YY MMM DD HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YY MMM DD HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMM YY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMM YY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMM YYYY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMM YYYY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YYYY MMM DD HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(\d{4}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YYYY MMM DD HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|[1-2]\d|3[0-1]) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMM DD YY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[1-2]\d|3[0-1]) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMM DD YY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|[1-2]\d|3[0-1]) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMM DD YYYY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[1-2]\d|3[0-1]) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMM DD YYYY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YY MMMM DD HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(\d{2}) (January|February|March|April|May|June|July|August|September|October|November|December) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YY MMMM DD HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMMM YY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMMM YY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (0[1-9]|[1-2]\d|3[0-1]) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMMM DD YY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) (0[1-9]|[1-2]\d|3[0-1]) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMMM DD YY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YYYY MMMM DD HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(\d{4}) (January|February|March|April|May|June|July|August|September|October|November|December) (0[1-9]|[1-2]\d|3[0-1]) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "YYYY MMMM DD HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMMM YYYY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "DD MMMM YYYY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (0[1-9]|[1-2]\d|3[0-1]) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMMM DD YYYY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(January|February|March|April|May|June|July|August|September|October|November|December) (0[1-9]|[1-2]\d|3[0-1]) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "MMMM DD YYYY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(lunes|martes|miércoles|miercoles|jueves|viernes|sábado|sabado|domingo), (0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{2})$/i,
        mask: "dddd, DD MMMM YY",
        locale: "es"
    },
    {
        regex: /^(monday|thuesday|wednesday|thursday|friday|saturday|sunday), (0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{2})$/i,
        mask: "dddd, DD MMMM YY",
        locale: "en"
    },
    {
        regex: /^(lunes|martes|miércoles|miercoles|jueves|viernes|sábado|sabado|domingo), (0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{4})$/i,
        mask: "dddd, DD MMMM YYYY",
        locale: "es"
    },
    {
        regex: /^(monday|thuesday|wednesday|thursday|friday|saturday|sunday), (0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{4})$/i,
        mask: "dddd, DD MMMM YYYY",
        locale: "en"
    },
    {
        regex: /^(lunes|martes|miércoles|miercoles|jueves|viernes|sábado|sabado|domingo), (0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "dddd, DD MMMM YY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(monday|thuesday|wednesday|thursday|friday|saturday|sunday), (0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{2}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "dddd, DD MMMM YY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(lunes|martes|miércoles|miercoles|jueves|viernes|sábado|sabado|domingo), (0[1-9]|[1-2]\d|3[0-1]) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "dddd, DD MMMM YYYY HH:mm:ss",
        locale: "es"
    },
    {
        regex: /^(monday|thuesday|wednesday|thursday|friday|saturday|sunday), (0[1-9]|[1-2]\d|3[0-1]) (January|February|March|April|May|June|July|August|September|October|November|December) (\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/i,
        mask: "dddd, DD MMMM YYYY HH:mm:ss",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(0?[1-9]|1[0-2])$/,
        mask: "YYYY-M"
    },
    {
        regex: /^(\d{4})\/([1-9]|1[0-2])$/,
        mask: "YYYY/M"
    },
    {
        regex: /^([1-9]|1[0-2])-(\d{4})$/,
        mask: "M-YYYY"
    },
    {
        regex: /^([1-9]|1[0-2])\/(\d{4})$/,
        mask: "M/YYYY"
    },
    {
        regex: /^([1-9]|1[0-2]) (\d{4})$/,
        mask: "M YYYY"
    },
    {
        regex: /^(\d{4})-(0[1-9]|1[0-2])$/,
        mask: "YYYY-MM"
    },
    {
        regex: /^(\d{4})\/(0[1-9]|1[0-2])$/,
        mask: "YYYY/MM"
    },
    {
        regex: /^(\d{4}) (0[1-9]|1[0-2])$/,
        mask: "YYYY MM"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(\d{4})$/,
        mask: "MM-YYYY"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(\d{4})$/,
        mask: "MM/YYYY"
    },
    {
        regex: /^(0[1-9]|1[0-2]) (\d{4})$/,
        mask: "MM YYYY"
    },
    {
        regex: /^([1-9]|1[0-2])-(\d{2})$/,
        mask: "M-YY"
    },
    {
        regex: /^([1-9]|1[0-2])\/(\d{2})$/,
        mask: "M/YY"
    },
    {
        regex: /^(\d{2})-([1-9]|1[0-2])$/,
        mask: "YY-M"
    },
    {
        regex: /^(\d{2})\/([1-9]|1[0-2])$/,
        mask: "YY/M"
    },
    {
        regex: /^(\d{2})-([1-9]|1[0-2])$/,
        mask: "YY M"
    },
    {
        regex: /^(0[1-9]|1[0-2])-(\d{2})$/,
        mask: "MM-YY"
    },
    {
        regex: /^(0[1-9]|1[0-2])\/(\d{2})$/,
        mask: "MM/YY"
    },
    {
        regex: /^(0[1-9]|1[0-2]) (\d{2})$/,
        mask: "MM YY"
    },
    {
        regex: /^(\d{2})-(0[1-9]|1[0-2])$/,
        mask: "YY-MM"
    },
    {
        regex: /^(\d{2})\/(0[1-9]|1[0-2])$/,
        mask: "YY/MM"
    },
    {
        regex: /^(\d{2}) (0[1-9]|1[0-2])$/,
        mask: "YY MM"
    },
    {
        regex: /^(\d{2})-(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)$/i,
        mask: "YY-MMMM",
        locale: "es"
    },
    {
        regex: /^(\d{2})\/(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)$/i,
        mask: "YY/MMMM",
        locale: "es"
    },
    {
        regex: /^(\d{2}) (enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)$/i,
        mask: "YY MMMM",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)-(\d{2})$/i,
        mask: "MMMM-YY",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)\/(\d{2})$/i,
        mask: "MMMM/YY",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{2})$/i,
        mask: "MMMM YY",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)-(\d{4})$/i,
        mask: "MMMM-YYYY",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)\/(\d{4})$/i,
        mask: "MMMM/YYYY",
        locale: "es"
    },
    {
        regex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre) (\d{4})$/i,
        mask: "MMMM YYYY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(\d{2})$/i,
        mask: "MMM-YY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\/(\d{2})$/i,
        mask: "MMM/YY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (\d{2})$/i,
        mask: "MMM YY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(\d{4})$/i,
        mask: "MMM-YYYY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\/(\d{4})$/i,
        mask: "MMM/YYYY",
        locale: "es"
    },
    {
        regex: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (\d{4})$/i,
        mask: "MMM YYYY",
        locale: "es"
    },
    {
        regex: /^(\d{4})-(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)$/i,
        mask: "YYYY-MMM",
        locale: "es"
    },
    {
        regex: /^(\d{4})\/(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)$/i,
        mask: "YYYY/MMM",
        locale: "es"
    },
    {
        regex: /^(\d{4}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)$/i,
        mask: "YYYY MMM",
        locale: "es"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december)\/(\d{4})$/i,
        mask: "MMMM/YY",
        locale: "en"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december)\/(\d{4})$/i,
        mask: "MMMM/YYYY",
        locale: "en"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december) (\d{4})$/i,
        mask: "MMMM YYYY",
        locale: "en"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december) (\d{2})$/i,
        mask: "MMMM YY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec) (\d{4})$/i,
        mask: "MMM YYYY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec) (\d{2})$/i,
        mask: "MMM YY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)-(\d{4})$/i,
        mask: "MMM-YYYY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\/(\d{4})$/i,
        mask: "MMM/YYYY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)-(\d{2})$/i,
        mask: "MMM-YY",
        locale: "en"
    },
    {
        regex: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\/(\d{2})$/i,
        mask: "MMM/YY",
        locale: "en"
    },
    {
        regex: /^(\d{2})-(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YY-MMM",
        locale: "en"
    },
    {
        regex: /^(\d{2})\/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YY/MMM",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YY MMM",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YYYY-MMM",
        locale: "en"
    },
    {
        regex: /^(\d{4})\/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YYYY/MMM",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
        mask: "YYYY MMM",
        locale: "en"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december)-(\d{4})$/i,
        mask: "MMMM-YYYY",
        locale: "en"
    },
    {
        regex: /^(\d{2})-(january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YY-MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{2})\/(january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YY/MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YY MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YYYY-MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{4})\/(january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YYYY/MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (january|february|march|april|may|june|july|august|september|october|november|december)$/i,
        mask: "YYYY MMMM",
        locale: "en"
    },
    {
        regex: /^(\d{4})-(january|february|march|april|may|june|july|august|september|october|november|december)-(0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YYYY-MMMM-DD",
        locale: "en"
    },
    {
        regex: /^(\d{4})\/(january|february|march|april|may|june|july|august|september|october|november|december)\/(0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YYYY/MMMM/DD",
        locale: "en"
    },
    {
        regex: /^(\d{4}) (january|february|march|april|may|june|july|august|september|october|november|december) (0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YYYY MMMM DD",
        locale: "en"
    },
    {
        regex: /^(january|february|march|april|may|june|july|august|september|october|november|december)-(\d{2})$/i,
        mask: "MMMM-YY",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YY MMM DD",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic) (0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YY MMM DD",
        locale: "es"
    },
    {
        regex: /^(\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YY-MMM-DD",
        locale: "en"
    },
    {
        regex: /^(\d{2}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)-(0[1-9]|[1-2]\d|3[0-1])$/i,
        mask: "YY-MMM-DD",
        locale: "es"
    },
    {
        regex: /^\d{4}-W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY-WW"
    },
    {
        regex: /^\d{4}-(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY-WW"
    },
    {
        regex: /^\d{4}-W([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY-W"
    },
    {
        regex: /^\d{4}-([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY-W"
    },
    {
        regex: /^\d{4}\/W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY/WW"
    },
    {
        regex: /^\d{4}\/(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY/WW"
    },
    {
        regex: /^\d{4}\/W([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY/W"
    },
    {
        regex: /^\d{4}\/([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY/W"
    },
    {
        regex: /^\d{4} W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY WW"
    },
    {
        regex: /^\d{4} (0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YYYY WW"
    },
    {
        regex: /^\d{2}-W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY-WW"
    },
    {
        regex: /^\d{2}-(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY-WW"
    },
    {
        regex: /^\d{2}\/W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY/WW"
    },
    {
        regex: /^\d{2}\/(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY/WW"
    },
    {
        regex: /^\d{2} W(0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY WW"
    },
    {
        regex: /^\d{2} (0[1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY WW"
    },
    {
        regex: /^W(0[1-9]|[1-4]\d|5[0-3])-\d{2}$/,
        mask: "WW-YY"
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3])-\d{2}$/,
        mask: "WW-YY"
    },
    {
        regex: /^W(0[1-9]|[1-4]\d|5[0-3])\/\d{2}$/,
        mask: "WW/YY"
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3])\/\d{2}$/,
        mask: "WW/YY"
    },
    {
        regex: /^W(0[1-9]|[1-4]\d|5[0-3]) \d{2}$/,
        mask: "WW YY"
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3]) \d{2}$/,
        mask: "WW YY"
    },
    {
        regex: /^W([1-9]|[1-4]\d|5[0-3])-\d{2}$/,
        mask: "W-YY"
    },
    {
        regex: /^([1-9]|[1-4]\d|5[0-3])-\d{2}$/,
        mask: "W-YY"
    },
    {
        regex: /^W([1-9]|[1-4]\d|5[0-3])\/\d{2}$/,
        mask: "W/YY"
    },
    {
        regex: /^([1-9]|[1-4]\d|5[0-3])\/\d{2}$/,
        mask: "W/YY"
    },
    {
        regex: /^W([1-9]|[1-4]\d|5[0-3]) \d{2}$/,
        mask: "W YY"
    },
    {
        regex: /^([1-9]|[1-4]\d|5[0-3]) \d{2}$/,
        mask: "W YY"
    },
    {
        regex: /^(\d{2})-W([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY-W"
    },
    {
        regex: /^(\d{2})-([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY-W"
    },
    {
        regex: /^(\d{2})\/W([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY/W"
    },
    {
        regex: /^(\d{2})\/([1-9]|[1-4]\d|5[0-3])$/,
        mask: "YY/W"
    },
    {
        regex: /^W(0[1-9]|[1-4]\d|5[0-3])-\d{4}$/,
        mask: "WW-YYYY",
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3])-\d{4}$/,
        mask: "WW-YYYY",
    },
    {
        regex: /^W([1-9]|[1-4]\d|5[0-3])-\d{4}$/,
        mask: "W-YYYY",
    },
    {
        regex: /^([1-9]|[1-4]\d|5[0-3])-\d{4}$/,
        mask: "W-YYYY",
    },
    {
        regex: /^W(0[1-9]|[1-4]\d|5[0-3])\/\d{4}$/,
        mask: "WW/YYYY",
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3])\/\d{4}$/,
        mask: "WW/YYYY",
    },
    {
        regex: /^W([1-9]|[1-4]\d|5[0-3])\/\d{4}$/,
        mask: "W/YYYY",
    },
    {
        regex: /^([1-9]|[1-4]\d|5[0-3])\/\d{4}$/,
        mask: "W/YYYY",
    },
    {
        regex: /^(0[1-9]|[1-4]\d|5[0-3]) \d{4}$/,
        mask: "WW YYYY",
    },
    {
        regex: /^W(([1-9]|[1-4]\d|5[0-3])º)-\d{4}$/,
        mask: "WW-YYYY",
        locale: "es"
    },
    {
        regex: /^(([1-9]|[1-4]\d|5[0-3])º)-\d{4}$/,
        mask: "WW-YYYY",
        locale: "es"
    },
    {
        regex: /^W(([1-9]|[1-4]\d|5[0-3])º)\/\d{4}$/,
        mask: "WW/YYYY",
        locale: "es"
    },
    {
        regex: /^((0[1-9]|[1-4]\d|5[0-3])º)\/\d{4}$/,
        mask: "WW/YYYY",
        locale: "es"
    },
    {
        regex: /^W((0[1-9]|[1-4]\d|5[0-3])º) \d{4}$/,
        mask: "WW YYYY",
        locale: "es"
    },
    {
        regex: /^((0[1-9]|[1-4]\d|5[0-3])º) \d{4}$/,
        mask: "WW YYYY",
        locale: "es"
    },
    {
        regex: /^\d{4}-Q[1-4]$/,
        mask: "YYYY-Q"
    },
    {
        regex: /^\d{4}\/Q[1-4]$/,
        mask: "YYYY/Q"
    },
    {
        regex: /^\d{4} Q[1-4]$/,
        mask: "YYYY Q"
    },
    {
        regex: /^\d{2}-Q[1-4]$/,
        mask: "YY-Q"
    },
    {
        regex: /^\d{2}\/Q[1-4]$/,
        mask: "YY/Q"
    },
    {
        regex: /^\d{2} Q[1-4]$/,
        mask: "YY Q"
    },
    {
        regex: /^Q[1-4]-\d{2}$/,
        mask: "Q-YY"
    },
    {
        regex: /^Q[1-4]\/\d{2}$/,
        mask: "Q/YY"
    },
    {
        regex: /^Q[1-4] \d{2}$/,
        mask: "Q YY"
    },
    {
        regex: /^Q[1-4]-\d{4}$/,
        mask: "Q-YYYY",
    },
    {
        regex: /^Q[1-4]\/\d{4}$/,
        mask: "Q/YYYY",
    },
    {
        regex: /^Q[1-4] \d{4}$/,
        mask: "Q YYYY",
    }
]

export default DATE_FORMAT_REGEX_PATTERNS